export default __webpack_public_path__ + "db919738e3f18f41f062d3b559949e01.svg";